import React from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { TwoColumnLayout } from "../templates";
import { settings, animations } from "../settings";

export const AccountNotConnected = () => {
  const history = useHistory();

  const handleBackToLogin = () => {
    history.push("/login");
  };

  const { animate } = settings;
  const { form } = animations;

  const leftContent = (
    <>
      <div className="flex gap-2 items-center mb-10">
        <img
          src="/design/images/login-page/breathe-logo-icon.svg"
          alt="Breathe logo icon"
          className="h-8 w-9"
        />
      </div>
      <div className="flex-1 flex flex-col items-center justify-center w-full">
        <img
          src="/design/images/login-page/illustration.webp"
          alt="People having a conversation"
          className="h-auto max-h-[360px]"
          style={{ maxWidth: "86%" }}
        />
      </div>
    </>
  );

  return (
    <>
      <Helmet>
        <title>Account Not Connected</title>
      </Helmet>
      <TwoColumnLayout leftContent={leftContent}>
        <div className="flex flex-col h-full">
          <div className="flex-1 flex flex-col items-center justify-center">
            <motion.div
              variants={form}
              initial={animate ? "hidden" : ""}
              animate={animate ? "show" : ""}
              className="w-full max-w-md"
            >
              <div className="mb-5">
                <h1 className="heading-responsive font-medium text-black tracking-tight mb-2">
                  We can&apos;t sign you in with that account
                </h1>
              </div>

              <div className="mb-6">
                <p className="text-sm login-text-foreground font-inter leading-relaxed mb-2">
                  The email address doesn&apos;t match your Breathe profile.
                </p>
                <p className="text-sm login-text-foreground font-inter leading-relaxed">
                  Please use your email and password instead, or check that your email address matches.
                </p>
              </div>

              <button
                type="button"
                onClick={handleBackToLogin}
                className="w-full login-button rounded-md login-bg-primary text-white text-sm font-normal flex items-center justify-center font-inter"
              >
                Back to login
              </button>
            </motion.div>
          </div>
        </div>
      </TwoColumnLayout>
    </>
  );
};

